import {
  ApolloCache,
  ApolloError,
  DefaultContext,
  FetchResult,
  MutationFunctionOptions,
} from '@apollo/client';
import { useState } from 'react';
import { getApolloErrorMessages } from '../../utils/get-apollo-error-messages';
import {
  CreateTagInput,
  CreateTagMutation,
  Exact,
  ListTagsDocument,
  useCreateTagMutation,
} from '../types';

interface UseCreateTagHook {
  createTag: (
    options?:
      | MutationFunctionOptions<
          CreateTagMutation,
          Exact<{
            createTagInput: CreateTagInput;
          }>,
          DefaultContext,
          ApolloCache<unknown>
        >
      | undefined,
  ) => Promise<
    FetchResult<
      CreateTagMutation,
      Record<string, unknown>,
      Record<string, unknown>
    >
  >;
  data: unknown;
  loading: boolean;
  error: ApolloError | undefined;
  errorMessages: string;
}

export const useCreateTag = (
  completeCallback: () => void,
): UseCreateTagHook => {
  const [errorMessages, setErrorMessages] = useState('');

  const [createTag, { data, loading, error }] = useCreateTagMutation({
    refetchQueries: [ListTagsDocument],
    onError: (error: ApolloError) => {
      setErrorMessages(getApolloErrorMessages(error));
    },
    onCompleted: () => {
      completeCallback();
    },
  });

  return { createTag, data, loading, error, errorMessages };
};
